import { motion } from 'framer-motion';
import {
  Box,
  Cloud,
  Code2,
  Database,
  Layout,
  Sparkles
} from 'lucide-react';

const features = [
  {
    icon: Layout,
    title: 'Frontend Development',
    description: 'Modern, responsive web applications built with React, TypeScript, and the latest frontend frameworks.',
  },
  {
    icon: Code2,
    title: 'Backend Development',
    description: 'Scalable APIs and services using Node.js, .NET, and serverless architectures for reliable performance.',
  },
  {
    icon: Cloud,
    title: 'AWS Cloud Solutions',
    description: 'Serverless architectures, Lambda functions, API Gateway, CloudFront, and S3 for cost-effective scaling.',
  },
  {
    icon: Database,
    title: 'Database Design & Management',
    description: 'PostgreSQL and DynamoDB solutions with optimized data modeling and query performance.',
  },
  {
    icon: Box,
    title: 'DevOps & Infrastructure',
    description: 'Infrastructure as Code with SST, Docker containerization, and automated deployment pipelines.',
  },
  {
    icon: Sparkles,
    title: 'AI Integration',
    description: 'Integrate AWS AI services (Bedrock, Agent Core) into applications with custom prompt engineering.',
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Development <span className="text-gradient">Services</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Full-stack web development, cloud infrastructure, and database design.
            Building modern, scalable applications with the latest technologies.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative"
            >
              <div className="glass-effect p-8 rounded-2xl h-full hover:scale-105 transition-transform duration-300">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 to-primary-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />

                <feature.icon className="w-12 h-12 text-primary-400 mb-4" />
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;